// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const ArrowDropUp = React.forwardRef(function ArrowDropUp(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="m7 14 5-5 5 5z"/></SvgIcon>;
});
export default ArrowDropUp;
